import ThemeColors from './ThemeColors';

const BLStyleGuide = {
  color: {
    background: ThemeColors.background,
    bodyText: ThemeColors.bodyText,
    title: ThemeColors.title,
    secondary: ThemeColors.secondary,
    tertiary: ThemeColors.tertiary,
    highlight: ThemeColors.highlight,
    detailText: ThemeColors.detailText,
    quarternary: ThemeColors.quarternary,
    buttonGray: ThemeColors.buttonGray,
    black: ThemeColors.black
  },
  font: {
    size: {
      finePrint: '.6em',
      tiny: '.8em',
      smallTiny: '1em',
      small: '1.2em',
      mediumSmall: '1.5em',
      medium: '2em',
      mediumLarge: '2.8em',
      large: '3.5em', 
      huge: '4.0em',
      massive: '4.5em'
    },
    family: {
      helveticaNeue: 'helvetica neue',
      monoFur: 'MonoFur',
      chivo: 'Chivo',
      axis: 'Axis',
    },
    weight: {
      oneHundred: '100',
      threeHunded: '300',
      fiveHundred: '500',
      sevenHundred: '700',
      nineHundred: '900',
      light: '100',
      medium: '400',
      heavy: '700'
    }
  }
}
export default BLStyleGuide

// const palette = {
//   white: '#000000',
//   black: '#0A0203',
//   darkGray: '#434246',
//   lightGray: '#C6c8c7',
//   yellow: '#FCD50B',
//   red: '#B21E27',
//   lightBlue: '#332D8C',
//   darkBlue: '#0D0047',
//   white: '#FFFFFF',
//   magenta: '#6B085A',
//   sunburnt: "#DE102C"
// }


// WEBPACK FOOTER //
// ./src/interface/AppStyles/BLStyleGuide.js